// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"ba7c947a","787":"29ca532c"}[chunkId] + ".chunk.js";
};